import { animate, state, style, transition, trigger } from '@angular/animations';
import { AfterViewInit, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material';
import { ActivatedRoute } from '@angular/router';
import { HotTableRegisterer } from '@handsontable/angular';
import { NotifierService } from 'angular-notifier';
import Handsontable from 'handsontable';
import { format } from 'date-fns';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { ToastrService } from 'ngx-toastr';
import { BehaviorSubject, forkJoin, Subscription } from 'rxjs';
import { Message } from 'src/app/core/class/message';
import { HandsontableFieldTypeContrants } from 'src/app/core/constants/handsontable-field-types';
import { CommonService } from 'src/app/core/services/common.service';
import { ConvertCurrencyService } from 'src/app/core/services/convert-currency.service';
import { CustomerService } from 'src/app/core/services/customer.service';
import { DcFieldConfigService } from 'src/app/core/services/dc-field-config.service';
import { DocumentTemplateService } from 'src/app/core/services/document-template.service';
import { DocumentService } from 'src/app/core/services/document.service';
import { HandsontableService } from 'src/app/core/services/handsontable.service';
import { TemplateFormService } from 'src/app/core/services/template-form.service';
import { BaseComponent } from 'src/app/shared/components/base/base.component';
import { FormData } from 'src/app/shared/models/form-data.model';
import { TemplateFile } from 'src/app/shared/models/template-file.model';
import { DocumentTypeService } from '../../../../../../../../core/services/document-type.service';
import { SelectDocumentTypeComponent } from '../../../select-document-type/select-document-type.component';
import { CreateContractMohaService } from 'src/app/core/services/create-contract-moha.service';



const DATA_TYPE_REF_CUSTOMER = "tham_chieu_ben_khach_hang";
const DATA_TYPE_REF_ENTERPRISE = "tham_chieu_ben_lap";
const DATA_TYPE_SELECT = "select";
const DATA_TYPE_CUSTOMER = "customer";
const CATEGORY_CUSTOMER_CODE = 'customer';
const TYPE_COMBOBOX = 'combobox';
const DATA_TYPE_REF = 'ref';
const CONTRACT_CODE_TYPE = 'contract_code'
const LIST_FIELD_CAN_CHANGE = ['email', 'phone', 'customerId', 'order'];
const FIXED_FUNCTION_MONEY_TO_TEXT = 'NUMBER_TO_MONEY_TEXT';
const FIXED_FUNCTION_NUMBER_TO_TEXT = 'NUMBER_TO_TEXT';

const FIXED_FUNCTION_SUM = 'SUM';

@Component({
    selector: 'app-form-template-moha',
    templateUrl: './form-template-moha.component.html',
    styleUrls: ['./form-template-moha.component.scss'],
    animations: [
        trigger('detailExpand', [
            state('void', style({ height: '0px', minHeight: '0', visibility: 'hidden' })),
            state('*', style({ height: '*', visibility: 'visible' })),
            transition('void <=> *', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
        ]),
    ],
})
export class FormTemplateMohaComponent extends BaseComponent implements OnInit, AfterViewInit {

    @BlockUI() blockUI: NgBlockUI;
    contract: any;
    contractCode: string = ''
    isOnAutoNumber:  boolean = false;
    private _hotSettingsDefault: Handsontable.GridSettings = {
        stretchH: 'all',
        rowHeaders: true,
        colWidths: [50, 150, 250, 150],
        columns: [
            {
                readOnly: true
            },
            {
                readOnly: true
            },
            {
                readOnly: false
            },
            {
                readOnly: true,
                renderer:function(instance, td, row, col, prop){
                    //Handsontable.renderers.HtmlRenderer.apply(this, arguments);
                    //console.log(td,row,col);
                    return td;
                }
            }
        ],
        formulas: true,
        colHeaders: ['STT', 'Tên', 'Giá trị', 'Ghi chú'],
        data: [],
        licenseKey: 'non-commercial-and-evaluation',
        height: 'calc(91vh - 189px - 1rem)',
        width: '100%',
        undo: true,
        hiddenRows: {
            rows: [],
            indicators: true
        },
        comments: true,
        contextMenu: false,
        rowHeights: '40px',
        columnHeaderHeight: 40,
        mergeCells: true
    }

    public modifiedTableSettings: Handsontable.GridSettings = {
        ...this._hotSettingsDefault
    };

    private _hotRegister = new HotTableRegisterer();

    private recordUserSign: any[] = [];

    private data: FormData;

    private templateFile: TemplateFile;
    private formValid: boolean = false;
    private proccessSuccess: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    subscriptions: Subscription = new Subscription();
    public certificateType: any[] = [];
    public show: boolean = true;
    public documentTypeEnterpriseId: string = '';
    public configAutoNumber = '';
    isBack: boolean = false;
    isUpdate: any = false;
    current: any = 0;
    configAutoNumberRefresh: string = '';
    refreshContractCode: boolean = false;
    isChangeTypeDocAndTemp: boolean = false;
    constructor(
        public commonService: CommonService,
        public message: Message,
        private notifier: NotifierService,
        public handsontableService: HandsontableService,
        public documentTemplateService: DocumentTemplateService,
        public templateFormService: TemplateFormService,
        public createContractMohaService: CreateContractMohaService,
        private toast: ToastrService,
        private cdr: ChangeDetectorRef,
        private dialog: MatDialog,
        public customerService: CustomerService,
        public documentService: DocumentService,
        public dcFieldConfig: DcFieldConfigService,
        public convertCurrencyService: ConvertCurrencyService,
        public documentTypeService: DocumentTypeService,
        private route: ActivatedRoute,
    ) {
        super(commonService, message);
        this.notifier = notifier;
        this.createContractMohaService.documentFileTemplate.subscribe(file => {
            if (file) {
                this.templateFile = file;
            }
        });
        this.isUpdate =  this.route.snapshot.queryParams && (this.route.snapshot.queryParams.typeUpdate || (this.route.snapshot.queryParams.goFrom =='mine' && !this.route.snapshot.queryParams.flagCopy));
        this.documentTypeEnterpriseId = this.createContractMohaService.selectedTemplate.getValue().id;
        //neu co thay doi giua file va mau va la them moi
        this.current = this.createContractMohaService.currentStep.getValue();
        if((this.createContractMohaService.refreshContractCode && this.createContractMohaService.refreshContractCode.getValue()) || (this.createContractMohaService.isChangeTypeDocAndTemp && this.createContractMohaService.isChangeTypeDocAndTemp.getValue())) {
            this.documentTypeService.getServiceTypeByDocumentTypeId(this.documentTypeEnterpriseId).subscribe(rs => {
                if (rs.data) {
                  //goi api khi doi file va mau hoac nhan refresh
                  //doi voi them moi
                  if(!this.isUpdate) {
                    this.createContractMohaService.isOnAutoNumber.next(rs.data.isOnAutoNumber);
                    this.isOnAutoNumber = rs.data.isOnAutoNumber;
                    if(rs.data.isOnAutoNumber) {
                        this.createContractMohaService.configAutoNumber.next(this.commonService.convertConfigAutoNumber(rs.data.configAutoNumber));
                        this.configAutoNumber = this.commonService.convertConfigAutoNumber(rs.data.configAutoNumber);
                    }
                  }else {
                      //neu doi sang mau danh so tu dong chu khong nhan nut refresh
                      if(rs.data.isOnAutoNumber && !(this.createContractMohaService.refreshContractCode && this.createContractMohaService.refreshContractCode.getValue())) {
                        this.isOnAutoNumber = rs.data.isOnAutoNumber;
                        this.configAutoNumber = this.commonService.convertConfigAutoNumber(rs.data.configAutoNumber);
                      }
                        //doi voi cap nhat va refresh = true thi hien ma moi,hoac cap nhat ma doi mau
                      if(this.createContractMohaService.refreshContractCode && this.createContractMohaService.refreshContractCode.getValue()) {
                        this.configAutoNumberRefresh = this.commonService.convertConfigAutoNumber(rs.data.configAutoNumber);
                        this.isOnAutoNumber = rs.data.isOnAutoNumber;
                      }

                  }
                }
              });
              this.refreshContractCode = this.createContractMohaService.refreshContractCode.getValue();
              this.isChangeTypeDocAndTemp = this.createContractMohaService.isChangeTypeDocAndTemp.getValue();
              //this.createContractMohaService.refreshContractCode.next(false)
              this.createContractMohaService.isChangeTypeDocAndTemp.next(false);
        }else {
            this.isOnAutoNumber = this.createContractMohaService.isOnAutoNumber.getValue();
            this.configAutoNumber = this.createContractMohaService.configAutoNumber.getValue();
        }
    }

    ngOnInit() {
        // const code = this.document && this.document.code ? this.document.code : ''
        // this.createContractMohaService.contractCode.next(code);
        this.subscribeValue();
        this.contract = this.createContractMohaService.document.getValue();
        this.isBack = this.createContractMohaService.backView.getValue();
    }

    subscribeValue () {
        this.subscriptions.add(
            this.createContractMohaService.document.asObservable().subscribe(rs => {
              this.contract = rs;
            })
        );
        this.subscriptions.add(
            this.createContractMohaService.isOnAutoNumber.asObservable().subscribe(rs => {
              this.isOnAutoNumber = rs;
            })
        );
    }


    ngAfterViewInit(): void {
        this.handsontableService.dirty.subscribe(ref => {
            if (ref) {
                this.createContractMohaService.isDirty = true;
            }
        })
    }

    generateForm(id: string, user: any[]) {
        this.documentTemplateService.genForm(id).subscribe(response => {
            if (!response || !response.data) {
                return;
            }
            this.data = response.data;
            this.mapDataUser(response.data, user);
        });
    }

    mapDataUser(data: FormData, users: any) {
        const api = [
            this.commonService.getCertificateType(),
            this.commonService.getRepresentativeCertificateType()
        ];
        const createSide = users.find(user => user.isCreatedSide);
        const customers = users.filter(user => { return !user.isCreatedSide });
        if (createSide) {
            api.push(this.templateFormService.getEnterprise(createSide.enterpriseId));
        } else {
            const enterpriseId = localStorage.getItem('enterpriseId');
            api.push(this.templateFormService.getEnterprise(enterpriseId));
        }
        if (customers.length) {
            const customerIds = customers.map(customer => {
                return customer.customerId
            });
            api.push(this.templateFormService.getCustomers(customerIds));
        }

        forkJoin(api).subscribe((response: any[]) => {
            if (!response || !response.length) {
                return;
            }
            const certificateType = response[0] && response[0].data ? response[0].data : [];
            const representativeCertificate = response[1] && response[1].data ? response[1].data : [];
            this.certificateType = certificateType.concat(representativeCertificate);
            let createSideData;
            let customerData = [];
            createSideData = this.mapDataEnterprise(response[2].data);
            if (createSideData) {
                createSideData.enterpriseId = createSide ? createSide.enterpriseId : localStorage.getItem('enterpriseId');
            }
            customerData = this.mapDataCustomer(customers, response[3] && response[3].data ? response[3].data : []);
            this.recordUserSign = customerData;
            this.fillData(createSideData, customerData, data);
        });
    }

    fillData(enterprise: any, customers: any[], data: FormData) {
        const dataForm = JSON.parse(JSON.stringify(data));
        let rows = dataForm.rows ? dataForm.rows : [];
        rows.forEach((item,index) => {
            if(item.cells.value && item.cells.value.dataType.code == CONTRACT_CODE_TYPE) {
                item.cells.value['value'] =  '';
                this._hotRegister.getInstance('template').setDataAtCell(index, 3, '');
                if (this.isOnAutoNumber) {
                    if (this.isUpdate) {
                        item.cells.value['value'] = this.contract.backUpCode ? this.contract.backUpCode : this.contract.code;
                    } else {
                        item.cells.value['value'] = this.configAutoNumber;
                        const errorMess = this.message.getMessage("handsontable.error.contract_code_note_auto_number");
                        this._hotRegister.getInstance('template').setDataAtCell(index, 3, errorMess);
                    }
                } else {
                    item.cells.value['value'] = this.contract.code ? this.contract.code : '';
                }
            }
        })
        const codeWithData: any = {};
        let indexCustomer = 0;
        let indexBonus = 0;
        const mergeCells = [];
        for (const [index, row] of rows.entries()) {
            row.cells.orderNo = { value: row.orderNo };
            if (row.children) {
                mergeCells.push({
                    row: index + indexBonus,
                    col: 1,
                    rowspan: 1,
                    colspan: 2
                });
                row.childCode = row.children.map(item => {
                    return item.cells.value.code;
                });
                const cacheChild = row.children.map(child => {
                    const cellValueChild = child.cells && child.cells.value ? child.cells.value : null;
                    child.cells.orderNo = { value: row.orderNo + '.' + child.orderNo };
                    if (child.cells && child.cells.name) {
                        child.cells.name.className = 'child';
                    }
                    if (cellValueChild && cellValueChild.defaultValue && !cellValueChild.value && cellValueChild.dataType && cellValueChild.dataType.code !== 'fixed') {
                        if (cellValueChild.type && (cellValueChild.type.code === HandsontableFieldTypeContrants.numberPercent || cellValueChild.type.code === HandsontableFieldTypeContrants.number || cellValueChild.type.code === HandsontableFieldTypeContrants.moneyFormat)) {
                            cellValueChild.value = cellValueChild.defaultValue.replace(',', '.').replace(/[\s]*\%/, '');
                        } else if (cellValueChild.type && cellValueChild.type.code === HandsontableFieldTypeContrants.checkbox) {
                            const checked = cellValueChild.data ? cellValueChild.data.find(item => item.value === cellValueChild.defaultValue) : null;
                            cellValueChild.value = checked ? JSON.stringify([checked.id]) : null;
                        } else if (cellValueChild.type && cellValueChild.type.code === HandsontableFieldTypeContrants.radio) {
                            const checked = cellValueChild.data.find(item => item.value === cellValueChild.defaultValue);
                            cellValueChild.value = checked ? checked.id : null;
                        } else {
                            cellValueChild.value = cellValueChild.defaultValue;
                        }
                    }

                    if (cellValueChild.type && (cellValueChild.type.code === HandsontableFieldTypeContrants.number || cellValueChild.type.code === HandsontableFieldTypeContrants.numberPercent || cellValueChild.type.code === HandsontableFieldTypeContrants.moneyFormat) && cellValueChild.value) {
                        cellValueChild.value = Number(cellValueChild.value);
                    } else if (cellValueChild.type && (cellValueChild.type.code === HandsontableFieldTypeContrants.number || cellValueChild.type.code === HandsontableFieldTypeContrants.moneyFormat) && cellValueChild.dataType && cellValueChild.dataType.code !== 'formula') {
                        cellValueChild.value = '0';
                    }

                    if (cellValueChild.type && (cellValueChild.type.code === HandsontableFieldTypeContrants.checkbox || cellValueChild.type.code === HandsontableFieldTypeContrants.radio) && cellValueChild.valueId) {
                        cellValueChild.value = cellValueChild.valueId;
                    }

                    if (cellValueChild.fixedFunction && cellValueChild.fixedFunction.code === 'NUMBER_TO_MONEY_TEXT' && cellValueChild.fixedFieldCode) {
                        const splitCode = cellValueChild.fixedFieldCode.split('-');
                        cellValueChild.fixedFieldCode = splitCode && splitCode[0] ? splitCode[0] : splitCode;
                        cellValueChild.fixedMoneyCode = splitCode && splitCode[1] ? splitCode[1] : null;
                    }

                    if (cellValueChild && cellValueChild.dataType && cellValueChild.dataType.code === DATA_TYPE_CUSTOMER && cellValueChild.type && cellValueChild.type.code === TYPE_COMBOBOX && cellValueChild.category && cellValueChild.category.code === CATEGORY_CUSTOMER_CODE) {
                        cellValueChild.data = customers.map(customer => {
                            customer.value = customer.name ? customer.name : '';
                            return customer
                        });
                        cellValueChild.value = customers[indexCustomer] && customers[indexCustomer].name ? customers[indexCustomer].name : '';
                        if (cellValueChild.code) {
                            codeWithData[cellValueChild.code] = customers[indexCustomer];
                        }
                        indexCustomer++;
                    }

                    if (cellValueChild && cellValueChild.dataType && cellValueChild.dataType.code === DATA_TYPE_REF_ENTERPRISE) {
                        const categoryFieldCode = cellValueChild.refCategoryField && cellValueChild.refCategoryField.code ? cellValueChild.refCategoryField.code : null;
                        if (enterprise && categoryFieldCode && enterprise[categoryFieldCode] != null) {
                            cellValueChild.value = enterprise[categoryFieldCode];
                            cellValueChild.valueId = enterprise.enterpriseId ? enterprise.enterpriseId : null;
                        }
                    }

                    if (cellValueChild.value && !codeWithData[cellValueChild.code]) {
                        if (cellValueChild.type && cellValueChild.type.code === TYPE_COMBOBOX) {
                            cellValueChild.data = cellValueChild.data ? cellValueChild.data : [];
                            const optionSelected = cellValueChild.data.find(item => item.value === cellValueChild.value);
                            if (optionSelected) {
                                codeWithData[cellValueChild.code] = optionSelected;
                            } else {
                                cellValueChild.value = null;
                            }
                        } else {
                            codeWithData[cellValueChild.code] = cellValueChild.value;
                        }
                    }
                    return child;
                });
                rows = [
                    ...rows.slice(0, index + indexBonus + 1),
                    ...cacheChild,
                    ...rows.slice(index + indexBonus + 1)
                ];

                indexBonus += cacheChild.length;
                continue;
            }
            const cellValue = row.cells && row.cells.value ? row.cells.value : null;
            if (cellValue && cellValue.defaultValue && !cellValue.value && cellValue.dataType && cellValue.dataType.code !== 'fixed') {
                if (cellValue.type && (cellValue.type.code === HandsontableFieldTypeContrants.numberPercent || cellValue.type.code === HandsontableFieldTypeContrants.number || cellValue.type.code === HandsontableFieldTypeContrants.moneyFormat)) {
                    cellValue.value = cellValue.defaultValue.replace(',', '.').replace(/[\s]*\%/, '');
                } else if (cellValue.type && cellValue.type.code === HandsontableFieldTypeContrants.checkbox) {
                    const checked = cellValue.data ? cellValue.data.find(item => item.value === cellValue.defaultValue) : null;
                    cellValue.value = checked ? JSON.stringify([checked.id]) : null;
                } else if (cellValue.type && cellValue.type.code === HandsontableFieldTypeContrants.radio) {
                    const checked = cellValue.data.find(item => item.value === cellValue.defaultValue);
                    cellValue.value = checked ? checked.id : null;
                } else {
                    cellValue.value = cellValue.defaultValue;
                }
            }

            if (cellValue.type && (cellValue.type.code === HandsontableFieldTypeContrants.number || cellValue.type.code === HandsontableFieldTypeContrants.numberPercent || cellValue.type.code === HandsontableFieldTypeContrants.moneyFormat) && cellValue.value) {
                cellValue.value = Number(cellValue.value);
            } else if (cellValue.type && (cellValue.type.code === HandsontableFieldTypeContrants.number || cellValue.type.code === HandsontableFieldTypeContrants.moneyFormat) && cellValue.dataType && cellValue.dataType.code !== 'formula') {
                cellValue.value = '0';
            }

            if (cellValue.type && (cellValue.type.code === HandsontableFieldTypeContrants.checkbox || cellValue.type.code === HandsontableFieldTypeContrants.radio) && cellValue.valueId) {
                cellValue.value = cellValue.valueId;
            }

            if (cellValue.fixedFunction && cellValue.fixedFunction.code === 'NUMBER_TO_MONEY_TEXT' && cellValue.fixedFieldCode) {
                const splitCode = cellValue.fixedFieldCode.split('-');
                cellValue.fixedFieldCode = splitCode && splitCode[0] ? splitCode[0] : splitCode;
                cellValue.fixedMoneyCode = splitCode && splitCode[1] ? splitCode[1] : null;
            }

            if (cellValue && cellValue.dataType && cellValue.dataType.code === DATA_TYPE_CUSTOMER && cellValue.type && cellValue.type.code === TYPE_COMBOBOX && cellValue.category && cellValue.category.code === CATEGORY_CUSTOMER_CODE) {
                cellValue.data = customers.map(customer => {
                    customer.value = customer.name ? customer.name : '';
                    return customer
                });
                cellValue.value = customers[indexCustomer] && customers[indexCustomer].name ? customers[indexCustomer].name : '';
                if (cellValue.code) {
                    codeWithData[cellValue.code] = customers[indexCustomer];
                }
                indexCustomer++;
            }

            if (cellValue && cellValue.dataType && cellValue.dataType.code === DATA_TYPE_REF_ENTERPRISE) {
                const categoryFieldCode = cellValue.refCategoryField && cellValue.refCategoryField.code ? cellValue.refCategoryField.code : null;
                if (enterprise && categoryFieldCode && enterprise[categoryFieldCode] != null) {
                    cellValue.value = enterprise[categoryFieldCode];
                    cellValue.valueId = enterprise.enterpriseId ? enterprise.enterpriseId : null;
                }
            }

            if (cellValue.value && !codeWithData[cellValue.code]) {
                if (cellValue.type && cellValue.type.code === TYPE_COMBOBOX) {
                    cellValue.data = cellValue.data ? cellValue.data : [];
                    const optionSelected = cellValue.data.find(item => item.value === cellValue.value);
                    if (optionSelected) {
                        codeWithData[cellValue.code] = optionSelected;
                    } else {
                        cellValue.value = null;
                    }
                } else {
                    codeWithData[cellValue.code] = cellValue.value;
                }
            }
        }

        for (const row of rows) {
            const cellValue = row.cells && row.cells.value ? row.cells.value : null;
            if (!cellValue) {
                continue;
            }
            if (cellValue.dataType && cellValue.dataType.code === DATA_TYPE_REF_CUSTOMER && cellValue.relatedFieldCode) {
                const categoryFieldCode = cellValue.refCategoryField && cellValue.refCategoryField.code ? cellValue.refCategoryField.code : null;
                const customer = codeWithData[cellValue.relatedFieldCode] ? codeWithData[cellValue.relatedFieldCode] : null;
                if (customer && categoryFieldCode && customer[categoryFieldCode] != null) {
                    cellValue.value = customer[categoryFieldCode];
                }
                continue;
            }
            // tham chieu danh muc
            if (cellValue.relatedFieldCode && codeWithData[cellValue.relatedFieldCode] && cellValue.dataType && cellValue.dataType.code === 'ref') {
                const objectData = codeWithData[cellValue.relatedFieldCode];
                cellValue.filterData = cellValue.data.filter(item => {
                    return item.parent_code === objectData.code
                });
                if (cellValue.filterData.length) {
                    cellValue.value = cellValue.filterData[0].value ? cellValue.filterData[0].value : null;
                }
                continue;
            }

            // truong co dinh
            if (cellValue.fixedFunction && cellValue.fixedFunction.code === FIXED_FUNCTION_SUM && !cellValue.value) {
                const field = rows.filter(row => {
                    return row.cells && row.cells.value && row.cells.value.value && row.cells.value.code.includes(cellValue.fixedFieldCode);
                });
                if (field.length) {
                    let sumResult = 0;
                    field.forEach(item => {
                        sumResult += Number(item.cells.value.value);
                    });
                    if (!isNaN(sumResult)) {
                        cellValue.value = sumResult.toString();
                    }
                }
                continue;
            } else if (cellValue.fixedFieldCode && !cellValue.value) {
                if (cellValue.fixedFunction && cellValue.fixedFunction.code === FIXED_FUNCTION_MONEY_TO_TEXT) {
                    const text = cellValue.defaultValue ? cellValue.defaultValue : null;
                    let numberText = '';
                    if (codeWithData[cellValue.fixedFieldCode] == 0) {
                        numberText = '0';
                    } else if (codeWithData[cellValue.fixedFieldCode]) {
                        codeWithData[cellValue.fixedFieldCode].toString()
                    }
                    cellValue.value = this.convertCurrencyService.convertToVietnamText(numberText, text);
                } else if (cellValue.fixedFunction && cellValue.fixedFunction.code === FIXED_FUNCTION_NUMBER_TO_TEXT) {
                    let numberText = '';
                    if (codeWithData[cellValue.fixedFieldCode] == 0) {
                        numberText = '0';
                    } else if (codeWithData[cellValue.fixedFieldCode]) {
                        codeWithData[cellValue.fixedFieldCode].toString()
                    }
                    cellValue.value = this.convertCurrencyService.convertToVietnamText(numberText, null);
                }
                continue;
            }
        }
        rows.forEach((element, index) => {
            const errorMess = this.message.getMessage("handsontable.error.contract_code_note_auto_number");
            if(element.cells.value && element.cells.value.dataType.code === CONTRACT_CODE_TYPE && !element.cells.value.value){
                if(this.isOnAutoNumber) {
                    element.cells['note'] = errorMess;
                    this._hotRegister.getInstance('template').setDataAtCell(index, 3, errorMess);
                }
            }
            if(this.isOnAutoNumber) {
                if(element.cells.value && element.cells.value.dataType.code === CONTRACT_CODE_TYPE) {
                    element.cells['note'] = this.message.getMessage("handsontable.error.contract_code_note_auto_number");
                    this._hotRegister.getInstance('template').setDataAtCell(index, 3, errorMess);
                }
            }
        });
        dataForm.rows = rows;
        dataForm.colHeaders = this._hotSettingsDefault.colHeaders as string[];
        this.data = dataForm;
        const settings = this.handsontableService.convertTableSettings(this._hotSettingsDefault, dataForm);
        this._hotRegister.getInstance('template').updateSettings(settings.settings);
        rows.forEach((element, index) => {
            if(element.cells.value && element.cells.value.dataType.code === CONTRACT_CODE_TYPE){
                if(this.isOnAutoNumber) {
                    const errorMess = this.message.getMessage("handsontable.error.contract_code_note_auto_number");
                    if(!this.isUpdate) {
                        this._hotRegister.getInstance('template').setDataAtCell(index, 3, errorMess);
                    }else {
                        if(!this.isBack && this.isUpdate){
                            this._hotRegister.getInstance('template').setDataAtCell(index, 3, errorMess);
                        } else {
                            this._hotRegister.getInstance('template').setDataAtCell(index, 3, '');
                        };
                    }

                }
            }
        });
        if (settings.hiddenRows) {
            const hiddenRowsPlugin = this._hotRegister.getInstance('template').getPlugin('hiddenRows');
            hiddenRowsPlugin.hideRows(settings.hiddenRows);
        }
        if (mergeCells.length) {
            setTimeout(() => {
                const mergeCellPlugin = this._hotRegister.getInstance('template').getPlugin('mergeCells');
                mergeCells.forEach(item => {
                    mergeCellPlugin.merge(item.row, 1, item.row, 2);
                })
            })
        }
        this._hotRegister.getInstance('template').render();
        if (rows.length) {
            // setTimeout(() => {
            //     if(!this.isOnAutoNumber) {
            //         this._hotRegister.getInstance('template').setDataAtCell(0, 3, '', 'change');
            //     }else {
            //         rows.forEach((item,index) => {
            //             if(item.cells.value && item.cells.value.dataType.code == CONTRACT_CODE_TYPE){
            //                 if(this.isOnAutoNumber) {
            //                     if(!this.contract.code) {
            //                         item.cells.value['value'] = this.configAutoNumber ? this.configAutoNumber : '';
            //                     }
            //                     this._hotRegister.getInstance('template').setDataAtCell(index, 3, '', 'change');
            //                     const errorMess = this.message.getMessage("handsontable.error.contract_code_note_auto_number");
            //                     this._hotRegister.getInstance('template').setDataAtCell(index, 3, errorMess);
            //                 }
            //             }
            //         })
            //     }
            // }, 100);
        }
    }

    exportDataField() {
        this.blockUI.start('');
        setTimeout(() => {
            const instance = this._hotRegister.getInstance('template');
            if (!instance) {
                this.exportDataField();
                return;
            }
            instance.validateCells(valid => {
                this.formValid = valid;
                this.proccessSuccess.next(true);
            });
            this.proccessSuccess.subscribe(status => {
                if (status) {
                    if (!this.formValid) {
                        this.createContractMohaService.isExportData.next(false);
                        const arrayInvalid = this.handsontableService.listRowInvalid.sort((a, b) => { return a - b });
                        instance.selectCell(arrayInvalid[0], 2);

                        // if (!this.handsontableService.dirty.getValue()) {
                        //     setTimeout(() => {
                        //         instance.selectCell(arrayInvalid[0], 2);
                        //     });
                        // }
                        this.blockUI.stop();
                        this.cdr.detectChanges();
                        this.proccessSuccess.next(false);
                        return;
                    }

                    this.contractCode = this.createContractMohaService.contractCode.getValue();

                    if (!this.handsontableService.dirty.getValue()
                        && this.createContractMohaService.pdfSrc.getValue()
                        && this.contractCode == this.contract.code) {
                        this.createContractMohaService.isExportData.next(false);
                        this.createContractMohaService.isSuccessStep2.next(true);
                        this.blockUI.stop();
                        this.cdr.detectChanges();
                        this.proccessSuccess.next(false);
                        return;
                    }

                    if(this.contractCode !== this.contract.code){
                        const code = this.contract && this.contract.code ? this.contract.code : ''
                        this.createContractMohaService.contractCode.next(code);
                    }
                    const fields = this.saveModelData();

                    let url = this.templateFile && this.templateFile.file && this.templateFile.file.url ? this.templateFile.file.url : null;
                    const document = this.createContractMohaService.document.getValue() as any;
                    if (document && document.templateFilePath) {
                        url = document.templateFilePath
                    }
                    if (!url) {
                        this.createContractMohaService.isExportData.next(false);
                        this.blockUI.stop();
                        this.cdr.detectChanges();
                        this.proccessSuccess.next(false);
                        return;
                    }
                    this.createContractMohaService.pdfSrcForm.next(null);
                    this.createContractMohaService.key = this.createContractMohaService.generateUUID();
                    const documentTypeEnterpriseId = this.createContractMohaService.selectedTemplate.getValue().id;
                    this.templateFormService.mergeDataToFile({ list: fields, url: url, code: this.createContractMohaService.key, documentTypeEnterpriseId }).subscribe(res => {
                        // if (res && res.type === 'application/json') {
                        //     this.createContractMohaService.isExportData.next(false);
                        //     this.proccessSuccess.next(false);
                        //     return;
                        // }
                        this.commonService.readFile(res, (pdfSrc) => {
                            this.createContractMohaService.pdfSrc.next(pdfSrc);
                            this.createContractMohaService.pdfSrcForm.next(pdfSrc);
                        });
                        /// merge 21511
                        let infoFile = [];
                        const reader = new FileReader();
                        reader.readAsBinaryString(res);
                        reader.onloadend = () => {
                            let count = 0;
                            let dataLoad:any = reader.result;
                            let match = dataLoad.match(/Type\/Pages\/Count (\d+)/);
                            if (match) {
                                count = match[1];
                            } else {
                                count = dataLoad.match(/\/Type[\s]*\/Page[^s]/g).length;
                            }
                            infoFile.push({
                                numberPage: Number(count),
                                size: res.size
                            })
                            this.createContractMohaService.infoFile.next(infoFile);
                            this.createContractMohaService.infoFileTemplate.next({
                                numberPage: Number(count),
                                size: res.size
                            });
                        }
                      /// merge 21511
                        this.createContractMohaService.changeFileOutput = false;
                        this.createContractMohaService.fileExport = res;
                        this.createContractMohaService.fieldData = fields;
                        this.createContractMohaService.tableModel = this.data;
                        this.createContractMohaService.isRenderNewFile = true;
                        this.createContractMohaService.isNewFileTag = true;
                        this.createContractMohaService.isExportData.next(false);
                        this.createContractMohaService.isSuccessStep2.next(true);
                        this.blockUI.stop();
                        this.cdr.detectChanges();
                        this.proccessSuccess.next(false);
                    });
                }
            });
        }, 500);
    }

    processDataWithModel(data: FormData, users: any, isCopy?: boolean) {
        const api = [
            this.commonService.getCertificateType(),
            this.commonService.getRepresentativeCertificateType()
        ];
        const createSide = users.find(user => user.isCreatedSide);
        const customers = users.filter(user => { return !user.isCreatedSide });
        const customerIds = customers.map(customer => {
            return customer.customerId
        });
        if (!isCopy) {
            const rows = data.rows;
            rows.forEach(row => {
                const cellValue = row.cells && row.cells.value ? row.cells.value : null;
                if (cellValue && cellValue.valueId && cellValue.category && cellValue.category.code === CATEGORY_CUSTOMER_CODE) {
                    if (!customerIds.includes(cellValue.valueId)) {
                        customerIds.push(cellValue.valueId);
                        customers.push({ name: cellValue.value, customerId: cellValue.valueId });
                    }
                }
                if (row.children) {
                    row.children.forEach(child => {
                        const cellValueChild = child.cells && child.cells.value ? child.cells.value : null;
                        if (cellValueChild && cellValueChild.valueId && cellValueChild.category && cellValueChild.category.code === CATEGORY_CUSTOMER_CODE) {
                            if (!customerIds.includes(cellValueChild.valueId)) {
                                customerIds.push(cellValueChild.valueId);
                                customers.push({ name: cellValueChild.value, customerId: cellValueChild.valueId });
                            }
                        }
                    })
                }
            });
        }
        if (customerIds.length) {
            api.push(this.templateFormService.getCustomers(customerIds));
        }
        if (isCopy) {
            if (createSide) {
                api.push(this.templateFormService.getEnterprise(createSide.enterpriseId));
            } else {
                const enterpriseId = localStorage.getItem('enterpriseId');
                api.push(this.templateFormService.getEnterprise(enterpriseId));
            }
        }
        forkJoin(api).subscribe((res: any[]) => {
            if (!res || !res.length) {
                return;
            }
            const certificateType = res[0] && res[0].data ? res[0].data : [];
            const representativeCertificate = res[1] && res[1].data ? res[1].data : [];
            this.certificateType = certificateType.concat(representativeCertificate);
            this.recordUserSign = this.mapDataCustomer(customers, customers.length && res[2] && res[2].data ? res[2].data : []);
            let createSideData = null;
            if ((res[3] && res[3].data) || (!customers.length && res[2] && res[2].data)) {
                createSideData = this.mapDataEnterprise(res[3] ? res[3].data : res[2].data);
                if (createSideData) {
                    createSideData.enterpriseId = createSide ? createSide.enterpriseId : localStorage.getItem('enterpriseId');
                }
            }
            this.fillDataToModel(this.recordUserSign, data, createSideData);
        })
    }

    fillDataToModel(customers: any, data: FormData, enterprise: any) {
        this.isOnAutoNumber = this.createContractMohaService.isOnAutoNumber.getValue();
        this.isBack = false;
        const dataForm = JSON.parse(JSON.stringify(data));
        let rows = data.rows ? data.rows : [];

        rows.forEach((item, index) => {
            if (item.cells.value && item.cells.value.dataType.code == "contract_code") {
                item.cells.value['value'] =  '';
                this._hotRegister.getInstance('template').setDataAtCell(index, 3, '');
                if (this.isOnAutoNumber) {
                    item.cells.value['value'] = this.configAutoNumber ? this.configAutoNumber : '';
                    const errorMess = this.message.getMessage("handsontable.error.contract_code_note_auto_number");
                    if (this.isUpdate && this.refreshContractCode) {
                        item.cells.value['value'] = this.createContractMohaService.configAutoNumber.value;
                        this._hotRegister.getInstance('template').setDataAtCell(index, 3, errorMess);
                    };
                    if (!this.isUpdate) {
                        item.cells.value['value'] = this.createContractMohaService.configAutoNumber.value;
                        this._hotRegister.getInstance('template').setDataAtCell(index, 3, errorMess);
                    };
                    //hien mahd moi neu doi mau + nhan refresh
                    if (this.isUpdate && this.refreshContractCode && !this.isChangeTypeDocAndTemp) {
                        item.cells.value['value'] = this.createContractMohaService.configAutoNumber.value;
                        this._hotRegister.getInstance('template').setDataAtCell(index, 3, errorMess);
                    }
                    if (this.isUpdate && !this.refreshContractCode && !this.isChangeTypeDocAndTemp) {
                        item.cells.value['value'] = this.contract.code ? this.contract.code : '';
                    }
                } else {
                    item.cells.value['value'] = this.contract.code ? this.contract.code : '';
                }
            }
        })
        const fields = this.createContractMohaService.fieldData ? this.createContractMohaService.fieldData : [];
        const mergeCells = [];
        const codeWithData: any = {};
        let indexBonus = 0;
        const dataChange = [];
        let indexCustomer = 0;
        const lang = localStorage.getItem('__language');
        for (const [index, row] of rows.entries()) {
            row.cells.orderNo = { value: row.orderNo };
            let field;
            if (row && row.fieldId) {
                field = fields.find(field => field.fieldId && field.fieldId === row.fieldId);
                if (field) {
                    row.field = JSON.parse(JSON.stringify(field));
                }
            }
            if (row.children) {
                mergeCells.push({
                    row: index + indexBonus,
                    col: 1,
                    rowspan: 1,
                    colspan: 2
                });
                row.childCode = row.children.map(item => {
                    return item.cells.value.code
                });
                const cacheChild = row.children.map((child, indexChild) => {
                    if (child.fieldId && field && field.children) {
                        const fieldChildFind = field.children.find(fieldChild => fieldChild.fieldId === child.fieldId);
                        if (fieldChildFind) {
                            child.field = JSON.parse(JSON.stringify(fieldChildFind));
                        }
                    }
                    const cellValueChild = child.cells && child.cells.value ? child.cells.value : null;
                    child.cells.orderNo = { value: row.orderNo + '.' + child.orderNo };
                    if (child.cells && child.cells.name) {
                        child.cells.name.className = 'child';
                    }

                    if (cellValueChild.type && (cellValueChild.type.code === HandsontableFieldTypeContrants.number || cellValueChild.type.code === HandsontableFieldTypeContrants.moneyFormat)) {
                        if (cellValueChild.value) {
                            let splitNumber;
                            let check = true;
                            if (lang === 'vi') {
                                splitNumber = cellValueChild.value.toString().split('.');
                            } else {
                                splitNumber = cellValueChild.value.toString().split(',');
                            }
                            if (splitNumber && splitNumber.length) {
                                splitNumber.forEach((item, indexNumber) => {
                                    if (!/^([0-9]){3}$/.test(item) && indexNumber < splitNumber.length - 1 && indexNumber > 0) {
                                        check = false;
                                    }
                                    if (indexNumber === 0 && !/^([0-9]){1,3}$/.test(item) && splitNumber.length > 1) {
                                        check = false;
                                    }
                                    if (indexNumber === splitNumber.length - 1) {
                                        if (indexNumber === 0) {
                                            switch (lang) {
                                                case 'vi': if (!/^([0-9]{1,3})(,[0-9]*)?$/.test(item)) {
                                                    check = false;
                                                }
                                                    break;
                                                case 'en': if (!/^([0-9]{1,3})(.[0-9]*)?$/.test(item)) {
                                                    check = false;
                                                }
                                                    break;
                                                default: break;
                                            }
                                        } else {
                                            switch (lang) {
                                                case 'vi': if (!/^([0-9]{3})(,[0-9]*)?$/.test(item)) {
                                                    check = false;
                                                }
                                                    break;
                                                case 'en': if (!/^([0-9]{3})(.[0-9]*)?$/.test(item)) {
                                                    check = false;
                                                }
                                                    break;
                                                default: break;
                                            }
                                        }
                                    }
                                })
                            }
                            if (check) {
                                cellValueChild.value = splitNumber.join('').replace(',', '.');
                            }
                        } else {
                            cellValueChild.value = '0';
                        }
                    }

                    if (cellValueChild.type && cellValueChild.type.code === HandsontableFieldTypeContrants.numberPercent) {
                        if (cellValueChild.value) {
                            if (/^([0-9]*)(,[0-9]*)?\%?$/.test(cellValueChild.value) && lang === 'vi') {
                                cellValueChild.value = cellValueChild.value.replace(',', '.').replace('%', '');
                            } else if (/^([0-9]*)(.[0-9]*)?\%?$/.test(cellValueChild.value) && lang === 'en') {
                                cellValueChild.value = cellValueChild.value.replace('%', '');
                            }
                        }
                    }

                    if (cellValueChild.type && cellValueChild.type.code === HandsontableFieldTypeContrants.combobox && cellValueChild.value && cellValueChild.value.substring(0, 1) == '{' && cellValueChild.value.substring(cellValueChild.value.length - 1) == '}') {
                        if (cellValueChild.valueId) {
                            const option = cellValueChild.data ? cellValueChild.data.find(op => op.id === cellValueChild.valueId) : null;
                            if (option && option.value) {
                                if (JSON.parse(cellValueChild.value).value && option.value != JSON.parse(cellValueChild.value).value) {
                                    dataChange.push([index + indexBonus + indexChild + 1, 2, option.value]);
                                } else {
                                    cellValueChild.value = JSON.parse(cellValueChild.value).value ? JSON.parse(cellValueChild.value).value : null;
                                }
                            } else {
                                cellValueChild.value = JSON.parse(cellValueChild.value).value ? JSON.parse(cellValueChild.value).value : null;
                            }
                        } else {
                            cellValueChild.value = JSON.parse(cellValueChild.value).value ? JSON.parse(cellValueChild.value).value : null;
                        }

                    }

                    if (cellValueChild && cellValueChild.dataType && cellValueChild.dataType.code === DATA_TYPE_CUSTOMER && cellValueChild.category && cellValueChild.category.code === CATEGORY_CUSTOMER_CODE) {
                        if (cellValueChild.valueId) {
                            const result = customers.filter(item => item.customerId === cellValueChild.valueId);
                            if (result && result.name && result.name !== cellValueChild.value) {
                                result.name = cellValueChild.value;
                            }
                        }
                        cellValueChild.data = customers.map(customer => {
                            customer.value = customer.name ? customer.name : '';
                            return customer
                        });
                    } else if (cellValueChild && cellValueChild.dataType && cellValueChild.dataType.code === DATA_TYPE_SELECT && cellValueChild.type && cellValueChild.type.code === TYPE_COMBOBOX && cellValueChild.valueId) {
                        const selected = cellValueChild.data ? cellValueChild.data.find(item => item.id === cellValueChild.valueId) : null;
                        if (!selected) {
                            if (cellValueChild.data) {
                                cellValueChild.data.push({ value: cellValueChild.value, id: cellValueChild.valueId });
                            } else {
                                cellValueChild.data = [{ value: cellValueChild.value, id: cellValueChild.valueId }];
                            }
                        }
                    } else if (cellValueChild && cellValueChild.dataType && cellValueChild.dataType.code === DATA_TYPE_REF && cellValueChild.valueId) {
                        const selected = cellValueChild.data ? cellValueChild.data.find(item => item.id === cellValueChild.valueId) : null;
                        if (selected) {
                            if (cellValueChild.value != selected.value) {
                                dataChange.push([index + indexBonus + indexChild + 1, 2, selected.value]);
                            }
                        }
                    }

                    if (cellValueChild.type && (cellValueChild.type.code === HandsontableFieldTypeContrants.checkbox || cellValueChild.type.code === HandsontableFieldTypeContrants.radio) && cellValueChild.valueId) {
                        if (cellValueChild.type.code === HandsontableFieldTypeContrants.checkbox) {
                            const selected = JSON.parse(cellValueChild.valueId);
                            const selectedValue = JSON.parse(cellValueChild.value);
                            selected.forEach((select, index) => {
                                const data = cellValueChild.data.find(item => item.id === select);
                                if (!data) {
                                    if (cellValueChild.data) {
                                        cellValueChild.data.push(selectedValue[index]);
                                    } else {
                                        cellValueChild.data = [selectedValue[index]];
                                    }
                                }
                            });
                        } else {
                            const selected = cellValueChild.data ? cellValueChild.data.find(item => item.id === cellValueChild.valueId) : null;
                            const objectValue = JSON.parse(cellValueChild.value);
                            if (!selected) {
                                if (cellValueChild.data) {
                                    cellValueChild.data.push(objectValue);
                                } else {
                                    cellValueChild.data = [objectValue];
                                }
                            }
                        }
                        cellValueChild.value = cellValueChild.valueId;
                    }

                    if (cellValueChild.fixedFunction && cellValueChild.fixedFunction.code === 'NUMBER_TO_MONEY_TEXT' && cellValueChild.fixedFieldCode) {
                        const splitCode = cellValueChild.fixedFieldCode.split('-');
                        cellValueChild.fixedFieldCode = splitCode && splitCode[0] ? splitCode[0] : splitCode;
                        cellValueChild.fixedMoneyCode = splitCode && splitCode[1] ? splitCode[1] : (cellValueChild.fixedMoneyCode ? cellValueChild.fixedMoneyCode : null);
                    }

                    if (cellValueChild && cellValueChild.dataType && cellValueChild.dataType.code === DATA_TYPE_CUSTOMER && cellValueChild.type && cellValueChild.type.code === TYPE_COMBOBOX && cellValueChild.category && cellValueChild.category.code === CATEGORY_CUSTOMER_CODE && enterprise) {
                        cellValueChild.data = customers.map(customer => {
                            customer.value = customer.name ? customer.name : '';
                            return customer
                        });
                        cellValueChild.value = customers[indexCustomer] && customers[indexCustomer].name ? customers[indexCustomer].name : '';
                        if (cellValueChild.code) {
                            codeWithData[cellValueChild.code] = customers[indexCustomer];
                        }
                        indexCustomer++;
                    }

                    if (cellValueChild && cellValueChild.dataType && cellValueChild.dataType.code === DATA_TYPE_REF_ENTERPRISE && enterprise) {
                        const categoryFieldCode = cellValueChild.refCategoryField && cellValueChild.refCategoryField.code ? cellValueChild.refCategoryField.code : null;
                        if (enterprise && categoryFieldCode && enterprise[categoryFieldCode] != null) {
                            cellValueChild.value = enterprise[categoryFieldCode];
                            cellValueChild.valueId = enterprise.enterpriseId ? enterprise.enterpriseId : null;
                            dataChange.push([index + indexBonus, 2, cellValueChild.value]);
                        }
                    }
                    if (cellValueChild.value && !codeWithData[cellValueChild.code]) {
                        if (cellValueChild.type && cellValueChild.type.code === TYPE_COMBOBOX) {
                            cellValueChild.data = cellValueChild.data ? cellValueChild.data : [];
                            const optionSelected = cellValueChild.data.find(item => item.value === cellValueChild.value);
                            if (optionSelected) {
                                codeWithData[cellValueChild.code] = optionSelected;
                            } else {
                                cellValueChild.value = null;
                            }
                        } else {
                            codeWithData[cellValueChild.code] = cellValueChild.value;
                        }
                    }
                    return child;
                });
                rows = [
                    ...rows.slice(0, index + indexBonus + 1),
                    ...cacheChild,
                    ...rows.slice(index + indexBonus + 1)
                ];
                indexBonus += cacheChild.length;
                continue;
            }
            const cellValue = row.cells && row.cells.value ? row.cells.value : null;
            if (cellValue.type && (cellValue.type.code === HandsontableFieldTypeContrants.number || cellValue.type.code === HandsontableFieldTypeContrants.moneyFormat)) {
                if (cellValue.value) {
                    let splitNumber;
                    let check = true;
                    if (lang === 'vi') {
                        splitNumber = cellValue.value.toString().split('.');
                    } else {
                        splitNumber = cellValue.value.toString().split(',');
                    }
                    if (splitNumber && splitNumber.length) {
                        splitNumber.forEach((item, indexNumber) => {
                            if (!/^([0-9]){3}$/.test(item) && indexNumber < splitNumber.length - 1 && indexNumber > 0) {
                                check = false;
                            }
                            if (indexNumber === 0 && !/^([0-9]){1,3}$/.test(item) && splitNumber.length > 1) {
                                check = false;
                            }
                            if (indexNumber === splitNumber.length - 1) {
                                if (indexNumber === 0) {
                                    switch (lang) {
                                        case 'vi': if (!/^([0-9]{1,3})(,[0-9]*)?$/.test(item)) {
                                            check = false;
                                        }
                                            break;
                                        case 'en': if (!/^([0-9]{1,3})(.[0-9]*)?$/.test(item)) {
                                            check = false;
                                        }
                                            break;
                                        default: break;
                                    }
                                } else {
                                    switch (lang) {
                                        case 'vi': if (!/^([0-9]{3})(,[0-9]*)?$/.test(item)) {
                                            check = false;
                                        }
                                            break;
                                        case 'en': if (!/^([0-9]{3})(.[0-9]*)?$/.test(item)) {
                                            check = false;
                                        }
                                            break;
                                        default: break;
                                    }
                                }
                            }
                        })
                    }
                    if (check) {
                        cellValue.value = splitNumber.join('').replace(',', '.');
                    }
                } else {
                    cellValue.value = '0';
                }
            }
            if (cellValue.type && cellValue.type.code === HandsontableFieldTypeContrants.numberPercent) {
                if (cellValue.value) {
                    if (/^([0-9]*)(,[0-9]*)?\%?$/.test(cellValue.value) && lang === 'vi') {
                        cellValue.value = cellValue.value.replace(',', '.').replace('%', '').trim();
                    } else if (/^([0-9]*)(.[0-9]*)?\%?$/.test(cellValue.value) && lang === 'en') {
                        cellValue.value = cellValue.value.replace('%', '').trim();
                    }
                }
            }
            if (cellValue.type && cellValue.type.code === HandsontableFieldTypeContrants.combobox && cellValue.value && cellValue.value.substring(0, 1) == '{' && cellValue.value.substring(cellValue.value.length - 1) == '}') {
                if (cellValue.valueId) {
                    const option = cellValue.data ? cellValue.data.find(op => op.id === cellValue.valueId) : null;
                    if (option && option.value) {
                        if (JSON.parse(cellValue.value).value && option.value != JSON.parse(cellValue.value).value) {
                            dataChange.push([index + indexBonus, 2, option.value]);
                        } else {
                            cellValue.value = JSON.parse(cellValue.value).value ? JSON.parse(cellValue.value).value : null;
                        }
                    } else {
                        cellValue.value = JSON.parse(cellValue.value).value ? JSON.parse(cellValue.value).value : null;
                    }
                } else {
                    cellValue.value = JSON.parse(cellValue.value).value ? JSON.parse(cellValue.value).value : null;
                }
            }
            if (cellValue && cellValue.dataType && cellValue.dataType.code === DATA_TYPE_CUSTOMER && cellValue.category && cellValue.category.code === CATEGORY_CUSTOMER_CODE) {
                if (cellValue.valueId) {
                    const result = customers.filter(item => item.customerId === cellValue.valueId);
                    if (result && result.name && result.name !== cellValue.value) {
                        result.name = cellValue.value;
                    }
                }
                cellValue.data = customers.map(customer => {
                    customer.value = customer.name ? customer.name : '';
                    return customer
                });
            } else if (cellValue && cellValue.dataType && cellValue.dataType.code === DATA_TYPE_SELECT && cellValue.type && cellValue.type.code === TYPE_COMBOBOX && cellValue.valueId) {
                const selected = cellValue.data ? cellValue.data.find(item => item.id === cellValue.valueId) : null;
                if (!selected) {
                    if (cellValue.data) {
                        cellValue.data.push({ value: cellValue.value, id: cellValue.valueId });
                    } else {
                        cellValue.data = [{ value: cellValue.value, id: cellValue.valueId }];
                    }
                }
            } else if (cellValue && cellValue.dataType && cellValue.dataType.code === DATA_TYPE_REF && cellValue.valueId) {
                const selected = cellValue.data ? cellValue.data.find(item => item.id === cellValue.valueId) : null;
                if (selected) {
                    if (cellValue.value != selected.value) {
                        dataChange.push([index + indexBonus, 2, selected.value]);
                    }
                }
            }

            if (cellValue.type && (cellValue.type.code === HandsontableFieldTypeContrants.checkbox || cellValue.type.code === HandsontableFieldTypeContrants.radio) && cellValue.valueId) {
                if (cellValue.type.code === HandsontableFieldTypeContrants.checkbox) {
                    const selected = JSON.parse(cellValue.valueId);
                    const selectedValue = JSON.parse(cellValue.value);
                    selected.forEach((select, index) => {
                        const data = cellValue.data.find(item => item.id === select);
                        if (!data) {
                            if (cellValue.data) {
                                cellValue.data.push(selectedValue[index]);
                            } else {
                                cellValue.data = [selectedValue[index]];
                            }
                        }
                    });
                } else {
                    const selected = cellValue.data ? cellValue.data.find(item => item.id === cellValue.valueId) : null;
                    if (!selected) {
                        if (cellValue.data) {
                            cellValue.data.push(JSON.parse(cellValue.value));
                        } else {
                            cellValue.data = [JSON.parse(cellValue.value)];
                        }
                    }
                }
                cellValue.value = cellValue.valueId;
            }

            if (cellValue.fixedFunction && cellValue.fixedFunction.code === 'NUMBER_TO_MONEY_TEXT' && cellValue.fixedFieldCode) {
                const splitCode = cellValue.fixedFieldCode.split('-');
                cellValue.fixedFieldCode = splitCode && splitCode[0] ? splitCode[0] : splitCode;
                cellValue.fixedMoneyCode = splitCode && splitCode[1] ? splitCode[1] : (cellValue.fixedMoneyCode ? cellValue.fixedMoneyCode : null);
            }

            if (cellValue && cellValue.dataType && cellValue.dataType.code === DATA_TYPE_CUSTOMER && cellValue.type && cellValue.type.code === TYPE_COMBOBOX && cellValue.category && cellValue.category.code === CATEGORY_CUSTOMER_CODE && enterprise) {
                cellValue.data = customers.map(customer => {
                    customer.value = customer.name ? customer.name : '';
                    return customer
                });
                cellValue.value = customers[indexCustomer] && customers[indexCustomer].name ? customers[indexCustomer].name : '';
                if (cellValue.code) {
                    codeWithData[cellValue.code] = customers[indexCustomer];
                }
                indexCustomer++;
            }

            if (cellValue && cellValue.dataType && cellValue.dataType.code === DATA_TYPE_REF_ENTERPRISE && enterprise) {
                const categoryFieldCode = cellValue.refCategoryField && cellValue.refCategoryField.code ? cellValue.refCategoryField.code : null;
                if (enterprise && categoryFieldCode && enterprise[categoryFieldCode] != null) {
                    cellValue.value = enterprise[categoryFieldCode];
                    cellValue.valueId = enterprise.enterpriseId ? enterprise.enterpriseId : null;
                    dataChange.push([index + indexBonus, 2, cellValue.value]);
                }
            }

            if (cellValue.value && !codeWithData[cellValue.code]) {
                if (cellValue.type && cellValue.type.code === TYPE_COMBOBOX) {
                    cellValue.data = cellValue.data ? cellValue.data : [];
                    const optionSelected = cellValue.data.find(item => item.value === cellValue.value);
                    if (optionSelected) {
                        codeWithData[cellValue.code] = optionSelected;
                    } else {
                        cellValue.value = null;
                    }
                } else {
                    codeWithData[cellValue.code] = cellValue.value;
                }
            }
        }

        for (const [rowIndex, row] of rows.entries()) {
            const cellValue = row.cells && row.cells.value ? row.cells.value : null;
            if (!cellValue) {
                continue;
            }
            if (cellValue.dataType && cellValue.dataType.code === DATA_TYPE_REF_CUSTOMER && cellValue.relatedFieldCode && enterprise) {
                const categoryFieldCode = cellValue.refCategoryField && cellValue.refCategoryField.code ? cellValue.refCategoryField.code : null;
                const customer = codeWithData[cellValue.relatedFieldCode] ? codeWithData[cellValue.relatedFieldCode] : null;
                if (customer && categoryFieldCode && customer[categoryFieldCode] != null) {
                    cellValue.value = customer[categoryFieldCode];
                    dataChange.push([rowIndex, 2, cellValue.value]);
                } else {
                    if (cellValue.type && (cellValue.type.code === HandsontableFieldTypeContrants.number || cellValue.type.code === HandsontableFieldTypeContrants.moneyFormat) && cellValue.dataType && cellValue.dataType.code !== 'formula') {
                        cellValue.value = '0';
                        dataChange.push([rowIndex, 2, cellValue.value]);
                    } else {
                        cellValue.value = '';
                        cellValue.valueId = null;
                        dataChange.push([rowIndex, 2, cellValue.value]);
                    }
                }
                continue;
            }
            // tham chieu danh muc
            if (cellValue.relatedFieldCode && codeWithData[cellValue.relatedFieldCode] && cellValue.dataType && cellValue.dataType.code === 'ref') {
                const objectData = codeWithData[cellValue.relatedFieldCode];
                cellValue.filterData = cellValue.data.filter(item => {
                    return item.parent_code === objectData.code
                });
                continue;
            }
        }

        dataForm.rows = rows;
        dataForm.colHeaders = this._hotSettingsDefault.colHeaders as string[];
        this.data = dataForm;

        const settings = this.handsontableService.convertTableSettings(this._hotSettingsDefault, dataForm);
        this._hotRegister.getInstance('template').updateSettings(settings.settings);
        rows.forEach((element, index) => {
            if(element.cells.value && element.cells.value.dataType.code === CONTRACT_CODE_TYPE && !element.cells.value.value){
                let errorMess = '';
                if(this.isOnAutoNumber) {
                    errorMess = this.message.getMessage("handsontable.error.contract_code_note_auto_number");
                }
                this._hotRegister.getInstance('template').setDataAtCell(index, 3, errorMess);
            }
            if(this.isOnAutoNumber) {
                if(element.cells.value && element.cells.value.dataType.code === CONTRACT_CODE_TYPE) {
                    const errorMess = this.message.getMessage("handsontable.error.contract_code_note_auto_number");
                  if(this.createContractMohaService.refreshContractCode.getValue() == true && this.isUpdate){
                    this._hotRegister.getInstance('template').setDataAtCell(index, 3, errorMess);
                  }
                  if(!this.isUpdate) {
                    this._hotRegister.getInstance('template').setDataAtCell(index, 3, errorMess);
                  }
                }
            }
        });
        if (settings.hiddenRows) {
            const hiddenRowsPlugin = this._hotRegister.getInstance('template').getPlugin('hiddenRows');
            hiddenRowsPlugin.hideRows(settings.hiddenRows);
        }
        if (mergeCells.length) {
            setTimeout(() => {
                const mergeCellPlugin = this._hotRegister.getInstance('template').getPlugin('mergeCells');
                mergeCells.forEach(item => {
                    mergeCellPlugin.merge(item.row, 1, item.row, 2);
                })
            })
        }
        this._hotRegister.getInstance('template').render();
        if (dataChange.length) {
            setTimeout(() => {
                this._hotRegister.getInstance('template').setDataAtCell(dataChange, 'first');
            }, 500);
        }
    }

    saveDataTable(isBack?: boolean) {
        setTimeout(() => {
            const instance = this._hotRegister.getInstance('template');
            instance.validateCells(valid => {
                this.createContractMohaService.isValidForm.next(valid);
            });
            const fields = this.saveModelData();
            this.createContractMohaService.fieldData = fields;
            this.createContractMohaService.tableModel = this.data;
            if (isBack) {
                this.createContractMohaService.saveDataTable.next(false);
                this.isBack = true
            } else {
                this.isBack = false
            }
        }, 500);
    }

    saveModelData() {
        const instance = this._hotRegister.getInstance('template');
        const listValue = instance.getDataAtCol(2);
        if (!this.data) {
            return [];
        }
        const dataField = this.data.rows.filter(row => {
            return row.cells && row.cells.orderNo && !/^[0-9]{1,}\.[0-9]{1,}$/.test(row.cells.orderNo.value.toString());
        });
        this.data.rows = dataField;

        const fields = dataField.map(row => {
            return row.field
        });
        let amountChild = 0;

        for (const [indexField, field] of fields.entries()) {
            const index = indexField + amountChild;
            const cellValue = this.data.rows[indexField] && this.data.rows[indexField].cells && this.data.rows[indexField].cells.value ? this.data.rows[indexField].cells.value : null;
            field.value = listValue[index] !== undefined ? (listValue[index] === -0 ? '0' : listValue[index]) : null;
            if (cellValue) {
                cellValue.value = field.value;
            }
            this.setDataToField(field, cellValue);
            if (field.children) {
                for (const [indexFieldChild, child] of field.children.entries()) {
                    const indexChild = index + indexFieldChild + 1;
                    const cellValueChild = this.data.rows[indexField].children[indexFieldChild].cells && this.data.rows[indexField].children[indexFieldChild].cells.value ? this.data.rows[indexField].children[indexFieldChild].cells.value : null;
                    child.value = listValue[indexChild] !== undefined ? (listValue[indexChild] === 0 ? '0' : listValue[indexChild]) : null;
                    if (cellValueChild) {
                        cellValueChild.value = child.value;
                    }
                    this.setDataToField(child, cellValueChild);
                }
                amountChild += field.children.length;
            }
        }

        return fields;
    }

    setDataToField(field: any, cellValue: any) {
        if (cellValue) {
            if (cellValue.formula && field.fieldConfig) {
                field.fieldConfig.formula = cellValue.formula;
            } else if (field.fieldConfig.formula && !cellValue.formula) {
                field.fieldConfig.formula = null;
            }
        }
        if (field.fieldConfig && field.fieldConfig.category && field.fieldConfig.category.code === CATEGORY_CUSTOMER_CODE) {
            const customer = this.recordUserSign.find(user => user.value === field.value);
            field.valueId = customer && customer.customerId ? customer.customerId : null;
            if (cellValue) {
                cellValue.valueId = customer && customer.customerId ? customer.customerId : null;
            }
        } else if (field.fieldConfig && field.fieldConfig.dataType && field.fieldConfig.dataType.code === DATA_TYPE_REF) {
            const option = cellValue.data.find(item => item.value == field.value);
            field.valueId = option && option.id ? option.id : null;
            if (cellValue) {
                cellValue.valueId = option && option.id ? option.id : null;
            }
        } else if (field.fieldConfig && field.fieldConfig.type && field.fieldConfig.type.code === HandsontableFieldTypeContrants.combobox && cellValue && cellValue.data) {
            const selected = cellValue.data.find(item => item.value === field.value);
            field.valueId = selected && selected.id ? selected.id : null;
            field.value = selected ? JSON.stringify(selected) : null;
            if (cellValue) {
                cellValue.valueId = selected && selected.id ? selected.id : null;
                cellValue.value = selected ? JSON.stringify(selected) : null;
            }
        } else if (field.fieldConfig && field.fieldConfig.type && field.fieldConfig.type.code === HandsontableFieldTypeContrants.radio && cellValue && cellValue.data) {
            const selected = cellValue.data.find(item => item.id === field.value);
            field.valueId = selected && selected.id ? selected.id : null;
            field.value = selected ? JSON.stringify(selected) : null;
            if (cellValue) {
                cellValue.valueId = selected && selected.id ? selected.id : null;
                cellValue.value = selected ? JSON.stringify(selected) : null;
            }
        } else if (field.fieldConfig && field.fieldConfig.type && field.fieldConfig.type.code === HandsontableFieldTypeContrants.checkbox && cellValue && cellValue.data) {
            const checked = field.value ? JSON.parse(field.value) : []
            const selected = cellValue.data.filter(item => { return checked.includes(item.id) });
            field.valueId = selected.length ? JSON.stringify(selected.map(item => { return item.id })) : null;
            field.value = selected.length ? JSON.stringify(selected.map(item => { return item })) : null;
            if (cellValue) {
                cellValue.valueId = selected.length ? JSON.stringify(selected.map(item => { return item.id })) : null;
                cellValue.value = selected.length ? JSON.stringify(selected.map(item => { return item })) : null;
            }
        }
    }

    mapDataCustomer(localData: any, apiData: any) {
        const lang = localStorage.getItem('__language');
        let mapApiData = [];
        apiData.forEach(user => {
            const dataLocal = localData.find(userLocal => userLocal.name === user.name);
            for (const key of Object.keys(user)) {
                if ((key.toLocaleLowerCase().includes('birthday') || key.toLocaleLowerCase().includes('date')) && user[key]) {
                    user[key] = format(user[key], 'DD/MM/YYYY');
                }
                if ((key === 'certificateId' || key === 'representativeCertificateId') && user[key]) {
                    const certificate = this.certificateType.find(item => item.id === user[key]);
                    if (certificate && certificate.langs) {
                        const text = certificate.langs.find(item => item.language === lang);
                        user[key] = text && text.name ? text.name : null;
                    }
                }
                if (key.toLocaleLowerCase().includes('sex') && user[key] !== null) {
                    user[key] = user[key] ? this.message.getMessage('form.male') : this.message.getMessage('form.female');
                }
            }
            LIST_FIELD_CAN_CHANGE.forEach(key => {
                user[key] = dataLocal && dataLocal[key] ? dataLocal[key] : (user[key] ? user[key] : null);
            })
            mapApiData.push(user);
        })
        mapApiData = mapApiData.sort((a, b) => { return a.order - b.order });

        return mapApiData;
    }

    mapDataEnterprise(user: any) {
        const lang = localStorage.getItem('__language');
        if (user) {
            for (const key of Object.keys(user)) {
                if (key.toLocaleLowerCase().includes('birthday') || key.toLocaleLowerCase().includes('date')) {
                    user[key] = format(user[key], 'DD/MM/YYYY');
                }
                if ((key === 'certificateId' || key === 'representativeCertificateId') && user[key]) {
                    const certificate = this.certificateType.find(item => item.id === user[key]);
                    if (certificate && certificate.langs) {
                        const text = certificate.langs.find(item => item.language === lang);
                        user[key] = text && text.name ? text.name : null;
                    }
                }
                if (key.toLocaleLowerCase().includes('sex') && user[key] !== null) {
                    user[key] = user[key] ? this.message.getMessage('form.male') : this.message.getMessage('form.female');
                }
            }
        }
        return user;
    }

    private documentInactiveHandler() {
        if (!this.toast.findDuplicate(this.message.getMessage("messages.confirm_use_inactive_template"), true, true)) {
            this.toast.error(this.message.getMessage("messages.confirm_use_inactive_template"));
            const dialogRef = this.dialog.open(SelectDocumentTypeComponent, {
                width: '30%',
                disableClose: true,
                data: { mode: null }
            });
            dialogRef.afterClosed().subscribe(result => {
                if (typeof result !== 'undefined') {
                    this.createContractMohaService.selectedTemplate.next(result.data.documentTypeEnterprise);
                }
            });
        }
    }

    public rerender(func: any) {
        this.show = false;
        setTimeout(() => {
            this.show = true;
        });
        setTimeout(() => {
            const instance = this._hotRegister.getInstance('template');
            instance.selectCell(0, 0);
            func();
        }, 100);
    }
}
